document.addEventListener('DOMContentLoaded', function() {
  const prevButtons = document.querySelectorAll('.multi-column__nav-prev');
  const nextButtons = document.querySelectorAll('.multi-column__nav-next');
  const containers = document.querySelectorAll('.multi-column');

  if (prevButtons.length > 0 && nextButtons.length > 0 && containers.length > 0) {
    prevButtons.forEach((prevButton, index) => {
      const container = containers[index];
      if (container) {
        prevButton.addEventListener('click', () => {
          container.scrollTo({ left: container.scrollLeft - container.offsetWidth, behavior: 'smooth' });
        });
      }
    });

    nextButtons.forEach((nextButton, index) => {
      const container = containers[index];
      if (container) {
        nextButton.addEventListener('click', () => {
          container.scrollTo({ left: container.scrollLeft + container.offsetWidth, behavior: 'smooth' });
        });
      }
    });
  } else {
    console.error('Navigation buttons or containers not found');
  }
});
